import React from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';

export default function ProposalManagementPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
            <Users size={56} style={{ color: 'var(--gold-primary)', marginBottom: '24px' }} />
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Proposal Management</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              Expert coordination of proposal teams, schedules, and deliverables to ensure on-time, compliant submissions that maintain quality under pressure.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-light">
        <div className="section-content">
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: '24px' }}>Need Proposal Management Support?</h2>
            <Link to="/contact" className="btn-primary">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
